"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenStax Open-Search API
 * A search engine for OpenStax open content.  Requests to this API should include `application/json` in the `Accept` header.  The desired API version is specified in the request URL, e.g. `[domain]/open-search/api/v0/search`.While the API does support a default version, that version will change overtime and therefore should not be used in production code!
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultHitSourceToJSON = exports.SearchResultHitSourceFromJSONTyped = exports.SearchResultHitSourceFromJSON = exports.SearchResultHitSourceElementTypeEnum = void 0;
/**
* @export
* @enum {string}
*/
var SearchResultHitSourceElementTypeEnum;
(function (SearchResultHitSourceElementTypeEnum) {
    SearchResultHitSourceElementTypeEnum["Paragraph"] = "paragraph";
    SearchResultHitSourceElementTypeEnum["Figure"] = "figure";
    SearchResultHitSourceElementTypeEnum["KeyTerm"] = "key_term";
})(SearchResultHitSourceElementTypeEnum = exports.SearchResultHitSourceElementTypeEnum || (exports.SearchResultHitSourceElementTypeEnum = {}));
function SearchResultHitSourceFromJSON(json) {
    return SearchResultHitSourceFromJSONTyped(json, false);
}
exports.SearchResultHitSourceFromJSON = SearchResultHitSourceFromJSON;
function SearchResultHitSourceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'pageId': json['page_id'],
        'elementType': json['element_type'],
        'elementId': json['element_id'],
        'pagePosition': json['page_position'],
    };
}
exports.SearchResultHitSourceFromJSONTyped = SearchResultHitSourceFromJSONTyped;
function SearchResultHitSourceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {};
}
exports.SearchResultHitSourceToJSON = SearchResultHitSourceToJSON;
